<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import dlwd from './dlwd/index.vue';
import {getdata as getdataII} from './dlwd/data.js';
import xmwd from './xmwd/index.vue';
import {getdata as getdataI} from './xmwd/data.js';
import uploadFile from '../../../common/uploadFile/index.vue'
export default {
	name: 'yffygl',
	components: {
		dlwd,
		xmwd,
		uploadFile
	},
	data() {
		return {
			filediag:false,
			a:[1,2],
			tablekey: 0,
			tableDataI:getdataI().tableData,
			ZeroHead:['xmwd'],
			searchdata: getdata().searchdata,
			searchlist: getdata().searchlist,
			pagination: getdata().pagination,
			headData: getdata().headData,
			tabledataII:[],
			upformdata:null,
			index:null,
			mxparams:{
				year:'',
				nsrmc:'',
				xmmc:''
			},
			tableData: [
				{ nsrmc: '一、自主研发、合作研发、集中研发',name:'xmwd_0_1_2'},
				{ nsrmc: '二、委托研发' ,name:'xmwd_0_1_35'},
				{ nsrmc: '三、年度研发费用小计',name:'xmwd_0_1_40' },
				{ nsrmc: '四、本年形成无形资产摊销额' ,name:'xmwd_0_1_43'},
				{ nsrmc: '五、以前年度形成无形资产本年摊销额' ,name:'xmwd_0_1_44'},
				{ nsrmc: '六、允许扣除的研发费用合计' ,name:'xmwd_0_1_45'},
				{ nsrmc: '七、允许扣除的研发费用抵减特殊收入后的金额' ,name:'xmwd_0_1_47'},
				{ nsrmc: '八、加计扣除比例 (%)' ,name:'xmwd_0_1_50'},
				{ nsrmc: '九、本年研发费用加计扣除总额',name:'xmwd_0_1_51' },
				{ nsrmc: '十、销售研发活动直接形成产品(包括组成部分)对应材料部分结转以后年度扣减金 额' ,name:'xmwd_0_1_52'}
			],
			searchdiag: false,
			shaidiag: false,
			sjlydiag: false,
			headlyData: getdata().headlyData,
			tablelyData: [{ isbjbc: true }],
			outlist: [],
			mxparams: {},
			showmxdj: 0,
			head:[],
			headI:[],
			userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
			chooseprop:""
		};
	},
	created() {
		this.width()
		this.searchlist[0].selectval=this.searchlist[0].selectval.filter(item=>item.label!=this.userInfo.deptName)
		this.searchlist[0].selectval.unshift({
			label:this.userInfo.deptName,
			value:this.userInfo.deptName
		})
		let arr=JSON.parse(JSON.stringify(this.searchlist))
		this.searchlist=arr
		this.searchdata.nsrmc=this.userInfo.deptName
		this.headData=this.$getSzBankStorage('yffyglheadData')||getdata().headData
		this.mxparams.nsrmc = this.userInfo.deptName
		this.mxparams.year = this.searchdata.year
		window.onresize = () =>{
			this.width()
		}
	},
	mounted() {},
	methods: {
		//文件导入
		file_import(){
			this.filediag = true
			this.upformdata = {
			  upfilename: "",
			  upfile: "",
			  filestate: "",
			  filetype: "",
			  filesize: "",
			}
		},
		deletes(e){
			this.tablelyData.splice(e,1)
		},
		//确认上传文件
		forupload(){
			
		},
		//获取上传文件流
		getuploadparams(){
			this.upformdata = e;
		},
		//下载标准模板
		fordownloadmb(){
			
		},
		width(){
			this.$nextTick(()=>{
				let width = this.$refs.boxtable.offsetWidth-(((this.headData[1].children.length-1)*85)+195+35)
				if(width<0){
					document.getElementsByClassName('boxtable_width')[0].style.width = ((width*-1)+this.$refs.boxtable.offsetWidth)+'px'
				}else{
					document.getElementsByClassName('boxtable_width')[0].style.width = '100%'
				}
			})
		},
		preservation(e){
			e.map(item=>{
				this.tableData.map(item1=>{
					if(item.xmwd.cellCode==item1.name){
						this.headData[1].children[this.index][item1.name] = item.xmwd.cellVal
					}
				})
			})
			let obj = {
				xmwd_0_1_2:0,xmwd_0_1_35:0,xmwd_0_1_40:0,xmwd_0_1_43:0,xmwd_0_1_44:0,
				xmwd_0_1_45:0,xmwd_0_1_47:0,xmwd_0_1_50:0,xmwd_0_1_51:0,xmwd_0_1_52:0,}
			this.headData[1].children[this.index].obj = e
			this.headData[1].children.map((item,index)=>{
				if(index!=0){
					this.tableData.map(item1=>{
						obj[item1.name] = Number(obj[item1.name]) + Number(item[item1.name]) 
					})
				}
			})
			this.tableData.map(item1=>{
				this.headData[1].children[0][item1.name] = this.toFixed(Number(obj[item1.name]),2) 
			})
			
			this.$setYfBankStorage('yffyglheadData',this.headData)
			this.$message.success('操作成功')
		},
		preservations(e){
			e.map(item=>{
				Object.keys(item).map(item1=>{
					if(item1!='name'&&item1!='jtfl'){
						this.headData[1].children.map(item2=>{
							if(item2.prop==item1){
								item2.obj.map(item3=>{
									if(item3.cellCode==item[item1].cellCode){
										item3.cellVal = item[item1].cellCode
									}
								})
							}
						})
					}
				})
			})
			let obj = ['xmwd_0_1_2','xmwd_0_1_35','xmwd_0_1_40','xmwd_0_1_43','xmwd_0_1_44','xmwd_0_1_45','xmwd_0_1_47','xmwd_0_1_50','xmwd_0_1_51','xmwd_0_1_52']
			this.headData[1].children.map((item,index)=>{
				if(index!=0){
					item.obj.map(item1=>{
						obj.map(item2=>{
							if(item1.xmwd.cellCode==item2){
							
								item[item2] = item1.xmwd.cellVal
							}
						})
					})
				}
			})
			this.$setYfBankStorage('yffyglheadData',this.headData)
			this.$message.success('操作成功')
			
		},
		nextproject(){
			 this.sjlydiag=false
			 let list = JSON.parse(JSON.stringify(this.tablelyData))
			 list.unshift(this.headData[1].children[0]) 
			 this.headData[1].children = list
			window.onresize = () =>{
				this.width()
			}
			this.$setYfBankStorage('yffyglheadData',this.headData)
			this.$message.success('操作成功')
		},
		addproject(){
			this.tablelyData = []
			this.headData[1].children.map((item,index)=>{
				if(index!=0){
					this.tablelyData.push({...item,isbjbc:true})
				}
			})
			this.sjlydiag=true
		},
		StatisticalCategory(e) {
			// this.mxparams = e;
			if(e==0){
				this.head = [
					{
						title: "具体分类",
						prop: "jtfl",
						width: 360,
						align: "left",
					},
				]
				this.headI = []
				this.headData[1].children.map((item,index)=>{
					if(index!=0){
						this.head.push(item)
						this.headI.push(item.prop)
					}
				})
				this.tabledataII = getdataII().tableData
				this.headData[1].children.map((item1,index)=>{
					this.tabledataII.map(item=>{
						if(index!=0){
							item1.obj.map(item2=>{
								if(item2.xmwd.cellCode==item.name){
									item[item1.prop] = item2.xmwd
								}
							})
						}
					})
				})
				this.$nextTick(()=>{
					this.showmxdj = 1;
				})
			}
		},
		Statistic(e,index) {
			this.index = index
			this.mxparams.xmmc = e.title
			this.tableDataI = JSON.parse(JSON.stringify(e.obj))
			this.showmxdj = 2;
		},
		forback() {
			// this.pagination.pageNum = 1;
			// this.pagination.paginationkey++;
			// this.yhsQuery()
			this.showmxdj = 0;
		},

		AddXm() {
			let one = this.headData[1].children[this.headData[1].children.length-1].prop
			let prop = one.split('s')
			this.tablelyData.push({
				AmountFormat: true ,
				custom: true ,
				headcustom: true ,
				headprop: "tes5_headprop",
				isbjbc: true,
				title:"",
				prop:'tes'+(Number(prop[1])+1),
				width:"80",
				obj:getdataI().tableData,
				xmwd_0_1_2:0,
				xmwd_0_1_35:0,
				xmwd_0_1_40:0,
				xmwd_0_1_43:0,
				xmwd_0_1_44:0,
				xmwd_0_1_45:0,
				xmwd_0_1_47:0,
				xmwd_0_1_50:0,
				xmwd_0_1_51:0,
				xmwd_0_1_52:0,
			});
		},
		closeshaidiag() {},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		submitSearch() {
			this.headData=this.$getSzBankStorage('yffyglheadData')||getdata().headData
			this.$emptyandnull(this.searchdata.year)?this.searchdata.year="2023":''
			this.$emptyandnull(this.searchdata.nsrmc)?this.searchdata.nsrmc=this.userInfo.deptName:''
			this.searchdata.year!="2023"||this.searchdata.nsrmc!=this.userInfo.deptName?this.headData=[]:''
		},
		sizechange(e) {
			this.pagination.pageSize = e;
		},
		currentChange(e) {
			this.pagination.pageNum = e;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		confirmfilter(e) {
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
		},
		inputblur(e,code,prop){
				if(prop&&prop!=''){
					this.chooseprop=prop
				}
				if (e.cellCode == "xmwd_0_1_2") {
					this.changetableval("xmwd_0_1_40", code, (this.gettableval("xmwd_0_1_2", code) +
						this.gettableval("xmwd_0_1_36", code)*0.8)+this.gettableval("xmwd_0_1_38", code))
				}
				if (e.cellCode == "xmwd_0_1_3") {
					
					this.changetableval("xmwd_0_1_2", code, this.gettableval("xmwd_0_1_3", code) +
						this.gettableval("xmwd_0_1_7", code) + this.gettableval("xmwd_0_1_16", code) +
						this.gettableval("xmwd_0_1_19", code) + this.gettableval("xmwd_0_1_23", code) +
						this.gettableval("xmwd_0_1_34", code) )
				}
				if (e.cellCode == "xmwd_0_1_4") {
					this.changetableval("xmwd_0_1_3", code, this.gettableval("xmwd_0_1_4", code) +
						this.gettableval("xmwd_0_1_5", code) + this.gettableval("xmwd_0_1_6", code))
				}
				if (e.cellCode == "xmwd_0_1_5") {
					this.changetableval("xmwd_0_1_3", code, this.gettableval("xmwd_0_1_4", code) +
						this.gettableval("xmwd_0_1_5", code) + this.gettableval("xmwd_0_1_6", code))
				}
				if (e.cellCode == "xmwd_0_1_6") {
					this.changetableval("xmwd_0_1_3", code, this.gettableval("xmwd_0_1_4", code) +
						this.gettableval("xmwd_0_1_5", code) + this.gettableval("xmwd_0_1_6", code))
				}
				if (e.cellCode == "xmwd_0_1_7") {
					this.changetableval("xmwd_0_1_2", code, this.gettableval("xmwd_0_1_3", code) +
						this.gettableval("xmwd_0_1_7", code) + this.gettableval("xmwd_0_1_16", code) +
						this.gettableval("xmwd_0_1_19", code) + this.gettableval("xmwd_0_1_23", code) +
						this.gettableval("xmwd_0_1_34", code) )
				}
				if (e.cellCode == "xmwd_0_1_8") {
					this.changetableval("xmwd_0_1_7", code, this.gettableval("xmwd_0_1_8", code) +
						this.gettableval("xmwd_0_1_9", code) + this.gettableval("xmwd_0_1_10", code) +
						this.gettableval("xmwd_0_1_11", code) + this.gettableval("xmwd_0_1_12", code) +
						this.gettableval("xmwd_0_1_13", code) + this.gettableval("xmwd_0_1_14", code) +
						this.gettableval("xmwd_0_1_15", code))
				}
				if (e.cellCode == "xmwd_0_1_9") {
					this.changetableval("xmwd_0_1_7", code, this.gettableval("xmwd_0_1_8", code) +
						this.gettableval("xmwd_0_1_9", code) + this.gettableval("xmwd_0_1_10", code) +
						this.gettableval("xmwd_0_1_11", code) + this.gettableval("xmwd_0_1_12", code) +
						this.gettableval("xmwd_0_1_13", code) + this.gettableval("xmwd_0_1_14", code) +
						this.gettableval("xmwd_0_1_15", code))
				}
				if (e.cellCode == "xmwd_0_1_10") {
					this.changetableval("xmwd_0_1_7", code, this.gettableval("xmwd_0_1_8", code) +
						this.gettableval("xmwd_0_1_9", code) + this.gettableval("xmwd_0_1_10", code) +
						this.gettableval("xmwd_0_1_11", code) + this.gettableval("xmwd_0_1_12", code) +
						this.gettableval("xmwd_0_1_13", code) + this.gettableval("xmwd_0_1_14", code) +
						this.gettableval("xmwd_0_1_15", code))
				}
				if (e.cellCode == "xmwd_0_1_11") {
					this.changetableval("xmwd_0_1_7", code, this.gettableval("xmwd_0_1_8", code) +
						this.gettableval("xmwd_0_1_9", code) + this.gettableval("xmwd_0_1_10", code) +
						this.gettableval("xmwd_0_1_11", code) + this.gettableval("xmwd_0_1_12", code) +
						this.gettableval("xmwd_0_1_13", code) + this.gettableval("xmwd_0_1_14", code) +
						this.gettableval("xmwd_0_1_15", code))
				}
				if (e.cellCode == "xmwd_0_1_12") {
					this.changetableval("xmwd_0_1_7", code, this.gettableval("xmwd_0_1_8", code) +
						this.gettableval("xmwd_0_1_9", code) + this.gettableval("xmwd_0_1_10", code) +
						this.gettableval("xmwd_0_1_11", code) + this.gettableval("xmwd_0_1_12", code) +
						this.gettableval("xmwd_0_1_13", code) + this.gettableval("xmwd_0_1_14", code) +
						this.gettableval("xmwd_0_1_15", code))
				}
				if (e.cellCode == "xmwd_0_1_13") {
					this.changetableval("xmwd_0_1_7", code, this.gettableval("xmwd_0_1_8", code) +
						this.gettableval("xmwd_0_1_9", code) + this.gettableval("xmwd_0_1_10", code) +
						this.gettableval("xmwd_0_1_11", code) + this.gettableval("xmwd_0_1_12", code) +
						this.gettableval("xmwd_0_1_13", code) + this.gettableval("xmwd_0_1_14", code) +
						this.gettableval("xmwd_0_1_15", code))
				}
				if (e.cellCode == "xmwd_0_1_14") {
					this.changetableval("xmwd_0_1_7", code, this.gettableval("xmwd_0_1_8", code) +
						this.gettableval("xmwd_0_1_9", code) + this.gettableval("xmwd_0_1_10", code) +
						this.gettableval("xmwd_0_1_11", code) + this.gettableval("xmwd_0_1_12", code) +
						this.gettableval("xmwd_0_1_13", code) + this.gettableval("xmwd_0_1_14", code) +
						this.gettableval("xmwd_0_1_15", code))
				}
				if (e.cellCode == "xmwd_0_1_15") {
					this.changetableval("xmwd_0_1_7", code, this.gettableval("xmwd_0_1_8", code) +
						this.gettableval("xmwd_0_1_9", code) + this.gettableval("xmwd_0_1_10", code) +
						this.gettableval("xmwd_0_1_11", code) + this.gettableval("xmwd_0_1_12", code) +
						this.gettableval("xmwd_0_1_13", code) + this.gettableval("xmwd_0_1_14", code) +
						this.gettableval("xmwd_0_1_15", code))
				}
				if (e.cellCode == "xmwd_0_1_16") {
					this.changetableval("xmwd_0_1_2", code, this.gettableval("xmwd_0_1_3", code) +
						this.gettableval("xmwd_0_1_7", code) + this.gettableval("xmwd_0_1_16", code) +
						this.gettableval("xmwd_0_1_19", code) + this.gettableval("xmwd_0_1_23", code) +
						this.gettableval("xmwd_0_1_34", code) )
				}
				if (e.cellCode == "xmwd_0_1_17") {
					this.changetableval("xmwd_0_1_16", code, this.gettableval("xmwd_0_1_17", code) +
						this.gettableval("xmwd_0_1_18", code) )
				}
				if (e.cellCode == "xmwd_0_1_18") {
					this.changetableval("xmwd_0_1_16", code, this.gettableval("xmwd_0_1_17", code) +
						this.gettableval("xmwd_0_1_18", code) )
				}
				if (e.cellCode == "xmwd_0_1_19") {
					this.changetableval("xmwd_0_1_2", code, this.gettableval("xmwd_0_1_3", code) +
						this.gettableval("xmwd_0_1_7", code) + this.gettableval("xmwd_0_1_16", code) +
						this.gettableval("xmwd_0_1_19", code) + this.gettableval("xmwd_0_1_23", code) +
						this.gettableval("xmwd_0_1_34", code) )
				}
				if (e.cellCode == "xmwd_0_1_20") {
					this.changetableval("xmwd_0_1_19", code, this.gettableval("xmwd_0_1_20", code) +
						this.gettableval("xmwd_0_1_21", code) + this.gettableval("xmwd_0_1_22", code))
				}
				if (e.cellCode == "xmwd_0_1_21") {
					this.changetableval("xmwd_0_1_19", code, this.gettableval("xmwd_0_1_20", code) +
						this.gettableval("xmwd_0_1_21", code) + this.gettableval("xmwd_0_1_22", code))
				}
				if (e.cellCode == "xmwd_0_1_22") {
					this.changetableval("xmwd_0_1_19", code, this.gettableval("xmwd_0_1_20", code) +
						this.gettableval("xmwd_0_1_21", code) + this.gettableval("xmwd_0_1_22", code))
				}
				if (e.cellCode == "xmwd_0_1_23") {
					this.changetableval("xmwd_0_1_2", code, this.gettableval("xmwd_0_1_3", code) +
						this.gettableval("xmwd_0_1_7", code) + this.gettableval("xmwd_0_1_16", code) +
						this.gettableval("xmwd_0_1_19", code) + this.gettableval("xmwd_0_1_23", code) +
						this.gettableval("xmwd_0_1_34", code) )
				}
				if (e.cellCode == "xmwd_0_1_24") {
					this.changetableval("xmwd_0_1_23", code, this.gettableval("xmwd_0_1_24", code) +
						this.gettableval("xmwd_0_1_25", code) + this.gettableval("xmwd_0_1_26", code) +
						this.gettableval("xmwd_0_1_27", code) )
				}
				if (e.cellCode == "xmwd_0_1_25") {
					this.changetableval("xmwd_0_1_23", code, this.gettableval("xmwd_0_1_24", code) +
						this.gettableval("xmwd_0_1_25", code) + this.gettableval("xmwd_0_1_26", code) +
						this.gettableval("xmwd_0_1_27", code) )
				}
				if (e.cellCode == "xmwd_0_1_26") {
					this.changetableval("xmwd_0_1_23", code, this.gettableval("xmwd_0_1_24", code) +
						this.gettableval("xmwd_0_1_25", code) + this.gettableval("xmwd_0_1_26", code) +
						this.gettableval("xmwd_0_1_27", code) )
				}
				if (e.cellCode == "xmwd_0_1_27") {
					this.changetableval("xmwd_0_1_23", code, this.gettableval("xmwd_0_1_24", code) +
						this.gettableval("xmwd_0_1_25", code) + this.gettableval("xmwd_0_1_26", code) +
						this.gettableval("xmwd_0_1_27", code) )
				}
				if (e.cellCode == "xmwd_0_1_27") {
					this.changetableval("xmwd_0_1_23", code, this.gettableval("xmwd_0_1_24", code) +
						this.gettableval("xmwd_0_1_25", code) + this.gettableval("xmwd_0_1_26", code) +
						this.gettableval("xmwd_0_1_27", code) )
				}
				if (e.cellCode == "xmwd_0_1_29") {
					this.changetableval("xmwd_0_1_28", code, this.gettableval("xmwd_0_1_29", code) +
						this.gettableval("xmwd_0_1_30", code) + this.gettableval("xmwd_0_1_31", code) +
						this.gettableval("xmwd_0_1_32", code) + this.gettableval("xmwd_0_1_33", code))
				}
				if (e.cellCode == "xmwd_0_1_30") {
					this.changetableval("xmwd_0_1_28", code, this.gettableval("xmwd_0_1_29", code) +
						this.gettableval("xmwd_0_1_30", code) + this.gettableval("xmwd_0_1_31", code) +
						this.gettableval("xmwd_0_1_32", code) + this.gettableval("xmwd_0_1_33", code))
				}
				if (e.cellCode == "xmwd_0_1_31") {
					this.changetableval("xmwd_0_1_28", code, this.gettableval("xmwd_0_1_29", code) +
						this.gettableval("xmwd_0_1_30", code) + this.gettableval("xmwd_0_1_31", code) +
						this.gettableval("xmwd_0_1_32", code) + this.gettableval("xmwd_0_1_33", code))
				}
				if (e.cellCode == "xmwd_0_1_32") {
					this.changetableval("xmwd_0_1_28", code, this.gettableval("xmwd_0_1_29", code) +
						this.gettableval("xmwd_0_1_30", code) + this.gettableval("xmwd_0_1_31", code) +
						this.gettableval("xmwd_0_1_32", code) + this.gettableval("xmwd_0_1_33", code))
				}
				if (e.cellCode == "xmwd_0_1_33") {
					this.changetableval("xmwd_0_1_28", code, this.gettableval("xmwd_0_1_29", code) +
						this.gettableval("xmwd_0_1_30", code) + this.gettableval("xmwd_0_1_31", code) +
						this.gettableval("xmwd_0_1_32", code) + this.gettableval("xmwd_0_1_33", code))
				}
				if (e.cellCode == "xmwd_0_1_34") {
					this.changetableval("xmwd_0_1_2", code, this.gettableval("xmwd_0_1_3", code) +
						this.gettableval("xmwd_0_1_7", code) + this.gettableval("xmwd_0_1_16", code) +
						this.gettableval("xmwd_0_1_19", code) + this.gettableval("xmwd_0_1_23", code) +
						this.gettableval("xmwd_0_1_34", code) )
				}
				if (e.cellCode == "xmwd_0_1_36") {
					this.changetableval("xmwd_0_1_35", code, this.gettableval("xmwd_0_1_36", code) +
						this.gettableval("xmwd_0_1_37", code) + this.gettableval("xmwd_0_1_39", code))
					this.changetableval("xmwd_0_1_40", code, (this.gettableval("xmwd_0_1_2", code) +
						this.gettableval("xmwd_0_1_36", code)*0.8)+this.gettableval("xmwd_0_1_38", code))
				}
				if (e.cellCode == "xmwd_0_1_37") {
					this.changetableval("xmwd_0_1_35", code, this.gettableval("xmwd_0_1_36", code) +
						this.gettableval("xmwd_0_1_37", code) + this.gettableval("xmwd_0_1_39", code))
				}
				if (e.cellCode == "xmwd_0_1_38") {
					this.changetableval("xmwd_0_1_40", code, (this.gettableval("xmwd_0_1_2", code) +
						this.gettableval("xmwd_0_1_36", code)*0.8)+this.gettableval("xmwd_0_1_38", code))
				}
				if (e.cellCode == "xmwd_0_1_39") {
					this.changetableval("xmwd_0_1_35", code, this.gettableval("xmwd_0_1_36", code) +
						this.gettableval("xmwd_0_1_37", code) + this.gettableval("xmwd_0_1_39", code))
				}
				if(e.cellCode == "xmwd_0_1_41"){
					this.changetableval("xmwd_0_1_45", code, this.gettableval("xmwd_0_1_41", code) +
						this.gettableval("xmwd_0_1_43", code) + this.gettableval("xmwd_0_1_44", code))
				}
				if(e.cellCode == "xmwd_0_1_43"){
					this.changetableval("xmwd_0_1_45", code, this.gettableval("xmwd_0_1_41", code) +
						this.gettableval("xmwd_0_1_43", code) + this.gettableval("xmwd_0_1_44", code))
				}
				if(e.cellCode == "xmwd_0_1_44"){
					this.changetableval("xmwd_0_1_45", code, this.gettableval("xmwd_0_1_41", code) +
						this.gettableval("xmwd_0_1_43", code) + this.gettableval("xmwd_0_1_44", code))
				}
				if(e.cellCode == "xmwd_0_1_45"){
					this.changetableval("xmwd_0_1_47", code, this.gettableval("xmwd_0_1_45", code) -
						this.gettableval("xmwd_0_1_46", code) + this.gettableval("xmwd_0_1_44", code))
				}
				if(e.cellCode == "xmwd_0_1_46"){
					this.changetableval("xmwd_0_1_47", code, this.gettableval("xmwd_0_1_45", code) +
						this.gettableval("xmwd_0_1_46", code) + this.gettableval("xmwd_0_1_44", code))
				}
				if(e.cellCode == "xmwd_0_1_47"){
					this.changetableval("xmwd_0_1_51", code, (this.gettableval("xmwd_0_1_47", code) -
						this.gettableval("xmwd_0_1_48", code) - this.gettableval("xmwd_0_1_49", code))*
						(this.gettableval("xmwd_0_1_50", code)*0.01))
					if((this.gettableval("xmwd_0_1_47", code) - this.gettableval("xmwd_0_1_48", code) -
						this.gettableval("xmwd_0_1_49", code))>=0){
								this.changetableval("xmwd_0_1_52", code,0)
						}else{
							this.changetableval("xmwd_0_1_52", code,(this.gettableval("xmwd_0_1_47", code) - 
								this.gettableval("xmwd_0_1_48", code) - this.gettableval("xmwd_0_1_49", code))*-1)
						}
				}
				if(e.cellCode == "xmwd_0_1_48"){
					this.changetableval("xmwd_0_1_51", code, (this.gettableval("xmwd_0_1_47", code) -
						this.gettableval("xmwd_0_1_48", code) - this.gettableval("xmwd_0_1_49", code))*
						(this.gettableval("xmwd_0_1_50", code)*0.01))
					if((this.gettableval("xmwd_0_1_47", code) - this.gettableval("xmwd_0_1_48", code) -
						this.gettableval("xmwd_0_1_49", code))>=0){
								this.changetableval("xmwd_0_1_52", code,0)
						}else{
							this.changetableval("xmwd_0_1_52", code,(this.gettableval("xmwd_0_1_47", code) - 
								this.gettableval("xmwd_0_1_48", code) - this.gettableval("xmwd_0_1_49", code))*-1)
						}
				}
				if(e.cellCode == "xmwd_0_1_49"){
					this.changetableval("xmwd_0_1_51", code, (this.gettableval("xmwd_0_1_47", code) -
						this.gettableval("xmwd_0_1_48", code) - this.gettableval("xmwd_0_1_49", code))*
						(this.gettableval("xmwd_0_1_50", code)*0.01))
					if((this.gettableval("xmwd_0_1_47", code) - this.gettableval("xmwd_0_1_48", code) -
						this.gettableval("xmwd_0_1_49", code))>=0){
								this.changetableval("xmwd_0_1_52", code,0)
						}else{
							this.changetableval("xmwd_0_1_52", code,(this.gettableval("xmwd_0_1_47", code) - 
								this.gettableval("xmwd_0_1_48", code) - this.gettableval("xmwd_0_1_49", code))*-1)
						}
				}
				if(e.cellCode == "xmwd_0_1_50"){
					this.changetableval("xmwd_0_1_51", code, (this.gettableval("xmwd_0_1_47", code) -
						this.gettableval("xmwd_0_1_48", code) - this.gettableval("xmwd_0_1_49", code))*
						(this.gettableval("xmwd_0_1_50", code)*0.01))
				}
		},
		gettableval(changecode, table, old) {
			var head = ''
			if (table == 'tableDataI') {
				head = 'ZeroHead'
			}
			if(table == 'tabledataII'){
				head = 'headI'
			}
			var a
			if (this[table] && this[head]) {
				for (let i = 0; i < this[table].length; i++) {
					for (let j = 0; j < this[head].length; j++) {
						let istrue = this.chooseprop==''?true:this[head][j]==this.chooseprop
						if (this[table][i][this[head][j]] 
							&& this[table][i][this[head][j]].cellCode 
							&& this[table][i][this[head][j]].cellVal 
							&& this[table][i][this[head][j]].cellCode == changecode
							&& istrue) {
							if (old) {
								if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
									a = 0
								} else {
									a = parseFloat(this[table][i][this[head][j]].goujgxValue)
								}
							} else {
								if (this[table][i][this[head][j]].cellVal == '- -') {
									a = 0
								} else {
									a = parseFloat(this[table][i][this[head][j]].cellVal || 0)
								}
							}
							break
						}
					}
				}
			}
			a = a || 0
			return a
		},
		
		changetableval(changecode, table, newval) {
			var newval = newval || 0
			newval = this.toFixed(newval,2)
			var head = ''
			if (table == 'tableDataI') {
				head = 'ZeroHead'
			}
			if(table == 'tabledataII'){
				head = 'headI'
			}
			for (let i = 0; i < this[table].length; i++) {
				for (let j = 0; j < this[head].length; j++) {
					let istrue = this.chooseprop==''?true:this[head][j]==this.chooseprop
					if (
						this[table][i][this[head][j]] 
						&& this[table][i][this[head][j]].cellCode 
						&& typeof this[table][i][this[head][j]].cellVal != 'undefined' 
						&& typeof this[table][i][this[head][j]].cellVal != undefined 
						&& this[table][i][this[head][j]].cellCode == changecode
						&& istrue
					) {
						
						if (this[table][i][this[head][j]].cellVal != newval ) {
								this[table][i][this[head][j]].cellVal = newval + ""
								
							this.inputblur({
								cellCode: changecode,
								cellVal: newval,
								prop:this.chooseprop
							},table,)
							break
						}
					}
				}
			}
		},
	}
};
</script>

<style scoped lang="less">
@import url('index.less');
</style>
